/**
 * 根据冲突文件名生成下一个候选名（纯函数，单测可独立 import）。
 * - `foo.png` -> `foo(1).png`
 * - `foo(1).png` -> `foo(2).png`
 * - `foo` -> `foo(1)` （无扩展名）
 * - 括号前不加空格
 * 如果生成的候选仍在 `existingNames` 中，会继续递增直到找到不冲突的名字。
 */
export const generateNextSuggestedName = (originalName: string, existingNames: Set<string>): string => {
  const dotIdx = originalName.lastIndexOf('.');
  const hasExt = dotIdx > 0 && dotIdx < originalName.length - 1;
  const base = hasExt ? originalName.slice(0, dotIdx) : originalName;
  const ext = hasExt ? originalName.slice(dotIdx) : '';

  const stemMatch = base.match(/^(.*)\((\d+)\)$/);
  const stem = stemMatch ? stemMatch[1] : base;
  let n = stemMatch ? Number.parseInt(stemMatch[2] ?? '0', 10) + 1 : 1;

  for (let guard = 0; guard < 10000; guard += 1) {
    const candidate = `${stem}(${n})${ext}`;
    if (!existingNames.has(candidate)) return candidate;
    n += 1;
  }
  return `${stem}(${n})${ext}`;
};
